"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useOnDeleteFile = function (inputRef, setFileName) {
    var onDeleteFile = (0, react_1.useCallback)(function (e) {
        e.stopPropagation();
        e.preventDefault();
        // eslint-disable-next-line
        if (inputRef && inputRef.current)
            inputRef.current.value = '';
        setFileName('');
    }, [
        inputRef,
        setFileName
    ]);
    return onDeleteFile;
};
exports.default = useOnDeleteFile;
